import React from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import Dashboard from "./Dashboard";
import StaffDashboard from "./StaffDashboard";

/** Renders staff home (shortcuts) or the full admin dashboard based on user type. */
function DashboardHome() {
  const user = getDecryptedUserFromCookie();
  if (String(user?.type ?? "").toLowerCase() === "staff") {
    return <StaffDashboard />;
  }
  return <Dashboard />;
}

export default DashboardHome;
